import type { NavigateFunction, To } from 'react-router';

export function relative(path: string, childrenPath: string) {
  return childrenPath.replace(path, '').replace(/^\//, '');
}

export type GoBackOneEntry = -1;

export function hasPreviousLocation() {
  return window.history.state?.idx > 0;
}

export const navigateBackOrFallback = (
  navigate: NavigateFunction,
  fallback: To
) => {
  if (hasPreviousLocation()) {
    navigate(-1);
    return;
  }
  navigate(fallback, { replace: true });
};
export const sportToBlogSportMap = {
  BASEBALL: 'mlb',
  FOOTBALL: 'football',
  NBA: 'nba',
  baseball: 'mlb',
  mlb: 'mlb',
  football: 'football',
  nba: 'nba',
} as const;
